import { useEffect, useState } from "react";
import { Loader2, FileText, CheckCircle2, DollarSign, AlertCircle, Users } from "lucide-react";
import { api } from "../../lib/api";
import { money } from "./common";

function Stat({ icon: Icon, label, value, sub }) {
  return (
    <div className="bg-white border border-border rounded-sm p-5" data-testid={`metric-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <span className="grid place-items-center w-10 h-10 rounded-sm bg-emerald/10 text-emerald mb-3"><Icon className="w-5 h-5" /></span>
      <p className="text-2xl font-700 text-charcoal">{value}</p>
      <p className="text-sm text-olive">{label}</p>
      {sub && <p className="text-xs text-charcoal/60 mt-1">{sub}</p>}
    </div>
  );
}

export default function MetricsPanel() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/metrics").then(({ data }) => setM(data)).catch(() => setM(false)); }, []);

  if (m === null) return <div className="flex items-center gap-2 text-olive py-10"><Loader2 className="w-5 h-5 animate-spin" /> Loading metrics…</div>;
  if (m === false) return <p className="text-olive">Unable to load metrics.</p>;

  return (
    <div data-testid="metrics-panel">
      <h2 className="font-display text-2xl font-600 text-charcoal mb-5">Business Metrics</h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <Stat icon={FileText} label="Quotes (Month)" value={m.quotes.month} sub={`${m.quotes.week} this week · ${m.quotes.all} all time`} />
        <Stat icon={CheckCircle2} label="Jobs Done (Month)" value={m.jobs_completed.month} sub={`${m.jobs_completed.week} this week · ${m.jobs_completed.all} all time`} />
        <Stat icon={DollarSign} label="Revenue (Month)" value={money(m.revenue.month)} sub={`${money(m.revenue.all)} all time`} />
        <Stat icon={AlertCircle} label="Outstanding" value={m.invoices.unpaid + m.invoices.overdue} sub={`${m.invoices.overdue} overdue`} />
      </div>
      <div className="bg-white border border-border rounded-sm p-6">
        <h3 className="font-600 text-charcoal flex items-center gap-2 mb-4"><Users className="w-5 h-5 text-emerald" /> Employee Completion Stats</h3>
        {m.employees.length === 0 ? <p className="text-olive text-sm">No employees yet.</p> : (
          <div className="space-y-2">
            {m.employees.map((e) => (
              <div key={e.employee_id} className="flex items-center justify-between py-2 border-b border-border last:border-0" data-testid={`emp-stat-${e.employee_id}`}>
                <span className="text-charcoal">{e.name}</span>
                <span className="font-600 text-emerald">{e.jobs_completed} jobs completed</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
